import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logout-icon",
  "use": "icon-logout-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-logout-icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 445.44l-195.584 180.224V508.928H506.88V381.952h321.536V265.216L1024 445.44zM690.176 41.984H100.352l314.368 133.12v630.784h275.456V551.936h46.08v296.96H414.72V1024L0 848.896V0h736.256v339.968h-46.08V41.984z\" p-id=\"1547\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol